(function () {
    'use strict';

    angular
        .module('app')
        .factory('copyurlservice', copyurlservice);

    copyurlservice.$inject = ['savedSearchService', 'favoritesService', 'gridDataService', 'searchService', '$timeout', '$state', '$localStorage'];

    function copyurlservice(savedSearchService, favoritesService, gridDataService, searchService, $timeout, $state, $localStorage) {
        var service = {
            getDocument: getDocument,
            getList: getList
        };
        var getType = {};

        return service;

        function getDocument(fileId) {
            savedSearchService.resetActive();
            favoritesService.resetActive();
            console.log("getDocument");
            var criteria = [{
                schemaID: 'SCHEMA_S_FILEID',
                valueStr: fileId,
                startDate: "",
                endDate: "",
                searchOp: 1, // Equals
                bSystem: true // System searches are not saved as last search.
            }];

            $localStorage.userSettings["searchCriteria"] = criteria;
            searchService.searchCriteria = criteria;

            gridDataService.genericDataService = searchService;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "searchService";
            //reset, since it's a new search
            gridDataService.totalRecords = 0;
            gridDataService.processing = true;

            //timeout so the overlay can be displayed and not the previous records.
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    $timeout(function () {
                        if (getType.toString.call(gridDataService.reloadGrid) === '[object Function]') {
                            gridDataService.reloadGrid();
                        }
                    });
                });
            }, 1000);
        }

        function getList(listId) {
            savedSearchService.resetActive();
            favoritesService.resetActive();
            console.log("getList");
            var fav = {
                id: listId,
                name: 'URL Navigation List',
                skip: -1,
                take: -1,
                sort: { SortField: 'SCHEMA_S_LONGNAME' }
            };

            //set the favorites service current item
            favoritesService.currentItem = fav;
            //set the grid's data service serivce identifier to be the favorite service
            gridDataService.serviceIdentifier = "favoritesService";
            //set the totalRecords to 0 which identifies this search as a new search
            gridDataService.totalRecords = 0;
            gridDataService.processing = true;
            //display the grid
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    if (getType.toString.call(gridDataService.reloadGrid) === '[object Function]') {
                        gridDataService.reloadGrid();
                    }
                });
            }, 1000);
            

        }

    }
})();